export const useCategoryConfigurationRoute = (): string => {
  return '/categories';
};
